import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOverseaWarehouseList(params) {
  return request({
    url: URL.mdm.overseaWarehouse.getOverseaWarehouseList,
    method: 'get',
    params
  })
}

export function advanceQuery(data) {
  return request({
    url: URL.mdm.overseaWarehouse.advanceQuery,
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: URL.mdm.overseaWarehouse.saveOverseaWarehouse,
    method: 'post',
    data
  })
}

export function getFbaAndOverseaWarehouseList(params) {
  return request({
    url: URL.mdm.overseaWarehouse.getFbaAndOverseaWarehouseList,
    method: 'get',
    params
  })
}

export function batchSave(data) {
  return request({
    url: URL.mdm.overseaWarehouse.batchSave,
    method: 'post',
    data
  })
}

export function batchDelete(data) {
  return request({
    url: URL.mdm.overseaWarehouse.batchDelete,
    method: 'delete',
    data
  })
}

export function getUsedOverseaWarehouse(data) {
  return request({
    url: URL.mdm.overseaWarehouse.getUsedOverseaWarehouse,
    method: 'delete',
    data
  })
}
